import React from 'react'
import Base from '../../../widgets/Link'
import PropTypes from 'prop-types'

const ExternalLink = ({
  children,
  href,
  title,
  tabIndex,
  onClick = null,
  preventDefault = true,
  openInNewPage = true,
  variant = 'inline',
  'aria-label': ariaLabel,
}) =>
  <Base
    href={ href }
    title={ title }
    tabIndex={ tabIndex }
    target={ openInNewPage ? '_blank' : '_self' }
    rel={ openInNewPage ? 'noopener noreferrer' : undefined }
    variant={ variant }
    aria-label={ ariaLabel }
    onClick={ onClick }
    preventDefault={ preventDefault }
  >
    { children }
  </Base>

ExternalLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  openInNewPage: PropTypes.bool,
  tabIndex: PropTypes.number,
  onClick: PropTypes.func,
  preventDefault: PropTypes.bool,
  variant: PropTypes.oneOf(['inline', 'inline-underlined', 'block', 'centered-block']),
  'aria-label': PropTypes.string,
}

export default ExternalLink
